import React from 'react';
import { Tag } from 'antd';
import './style.scss';

export const MyTag = ({
  children,
  status = '',
  className = '',
  type = 'ellipse',
  ...rest
}) => {
  const Dot = () => {
    return (
      <div className="dot-wrapper">
        <div className={`status ${status}`}></div>
      </div>
    );
  };
  return type === 'ellipse' ? (
    <Tag className={`my-tag ${status} ${className}`} {...rest}>
      {children}
    </Tag>
  ) : (
    <Dot />
  );
};

export default MyTag;
